import { SCADATypeBase } from './base/s-c-a-d-a-type-base';

export class SCADAType extends SCADATypeBase { }